export default {"src":"/_next/static/media/plane.ebda0174.svg","height":15,"width":17};